import '../../app.es6';
import angular from 'angular';

class PasswordChangeController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location, $window, $timeout,
    commonAuthFactory, commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.$window = $window;
    this.$timeout = $timeout;
    this.commonAuthFactory = commonAuthFactory;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    // エラー領域初期化
    this.isPleaseInput = false;      // 入力チェック
    this.isLoginFailed = false;      // 現在のパスワードチェック
    this.isSamePassword = false;     // 現在パスワード = 新しいパスワード
    this.isProhibitionChars = false; // 禁則文字チェック
    this.isMismatchPassword = false; // 新しいパスワード != 新しいパスワード確認
    this.isPasswordPolicy = false;   // パスワードポリシーチェック
    this.isChangeSuccess = false;    // パスワード変更完了
    this.isLimit = false;            // 一定時間内のパスワード変更可能回数エラー

    Page.setTitle(this.Const.TITLE.passChange);

    PasswordChangeController.$inject = [
      '$scope', '$sessionStorage', '$location', '$window', '$timeout',
      'commonAuthFactory', 'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  submit () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
      this.commonFactory.overlayShow();
    }

    // 仮パスワード/本パスワード
    let nowPass = this.$sessionStorage[this.Const.SSAPP_IS_TMP_PASSWORD] ? this.tmpPass : this.oldPass;
    // 新しいパスワード
    let newPass = this.newPass;
    // 新しいパスワードの確認
    let confirmPass = this.confirmPass;
    // パスワードが未入力
    if (!nowPass || !newPass || !confirmPass) {
      this.commonFactory.overlayHidden();
      return this.switchErrorMessage(this.Const.ERROR_TYPE.pleaseInput);
    }
    // 新しいパスワード != 新しいパスワードの確認
    if (newPass !== confirmPass) {
      this.commonFactory.overlayHidden();
      return this.switchErrorMessage(this.Const.ERROR_TYPE.mismatchPassword);
    }
    // 現在パスワード = 新しいパスワード
    if (nowPass === newPass) {
      this.commonFactory.overlayHidden();
      return this.switchErrorMessage(this.Const.ERROR_TYPE.samePassword);
    }
    // 禁則文字
    if (this.commonFactory.isProhibitionChars(newPass)) {
      this.commonFactory.overlayHidden();
      return this.switchErrorMessage(this.Const.ERROR_TYPE.prohibitionChars);
    }

    // 妥当チェック
    // アルファベット小文字、数字(アルファベット大文字、記号は任意)を1文字以上含む8文字以上か
    if (newPass.length < 8 || !this.commonFactory.isPasswordPolicy(this.newPass)) {
      this.commonFactory.overlayHidden();
      return this.switchErrorMessage(this.Const.ERROR_TYPE.passwordPolicy);
    }

    if (this.$sessionStorage[this.Const.SSAPP_IS_TMP_PASSWORD]) {
      let id = localStorage.getItem(this.Const.LSKEY_USER_ID);
      if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
        this.userLogin(id, nowPass, newPass);
      } else {
        this.staffLogin(id, nowPass, newPass);
      }
    } else {
      this.commonAuthFactory.changePassword(nowPass, newPass).then(() => {
        this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
        this.isChangeSuccess = true;
        this.$scope.$apply();
        this.$timeout(() => {
          this.commonFactory.overlayHidden();
          this.$scope.$apply();
          this.$window.history.back();
        }, 1500);
      })
      .catch((error) => {
        console.log('error : ', error);
        if (error) {
          if (error.statusCode === 400 && ~error.message.indexOf('limit exceeded')) {
            this.switchErrorMessage(this.Const.ERROR_TYPE.limit);
          } else {
            this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
          }
        } else {
          this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
        }
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      });
    }
  }

  cancel () {
    this.$window.history.back();
  }

  switchErrorMessage (errorType) {
    switch (errorType) {
      case this.Const.ERROR_TYPE.loginFailed:
        this.changeErrorMessage(true, false, false, false, false, false, false);
        break;
      case this.Const.ERROR_TYPE.samePassword:
        this.changeErrorMessage(false, true, false, false, false, false, false);
        break;
      case this.Const.ERROR_TYPE.prohibitionChars:
        this.changeErrorMessage(false, false, true, false, false, false, false);
        break;
      case this.Const.ERROR_TYPE.mismatchPassword:
        this.changeErrorMessage(false, false, false, true, false, false, false);
        break;
      case this.Const.ERROR_TYPE.pleaseInput:
        this.changeErrorMessage(false, false, false, false, true, false, false);
        break;
      case this.Const.ERROR_TYPE.passwordPolicy:
        this.changeErrorMessage(false, false, false, false, false, true, false);
        break;
      case this.Const.ERROR_TYPE.limit:
        this.changeErrorMessage(false, false, false, false, false, false, true);
        break;
      case this.Const.ERROR_TYPE.clear:
        this.changeErrorMessage(false, false, false, false, false, false, false);
        break;
      default:
        this.changeErrorMessage(false, false, false, false, false, false, false);
    }
  }

  changeErrorMessage (loginFailedFlag, samePasswordFlag, prohibitionCharsFlag,
                      mismatchPassword, pleaseInput, passwordPolicy, limit) {
    this.isLoginFailed = loginFailedFlag;
    this.isSamePassword = samePasswordFlag;
    this.isProhibitionChars = prohibitionCharsFlag;
    this.isMismatchPassword = mismatchPassword;
    this.isPleaseInput = pleaseInput;
    this.isPasswordPolicy = passwordPolicy;
    this.isLimit = limit;
  }

  userLogin (id, tmpPass, newPass) {
    let userAuth = this.commonAuthFactory.userLogin;
    userAuth(id, tmpPass, newPass).then((userCredentials) => {
      return this.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(this.Const.LSAPP_ROLE));
    })
    .then(() => {
      return this.commonApiFactory.getMembersMe();
    })
    .then((member) => {
      this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
      this.isChangeSuccess = true;
      this.$scope.$apply();
      this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_MEMBER);
      // 生徒情報を追加時に他修正が必要な箇所
      // ・member-sign-in-controller.es6
      // ・simplicity-sign-in-controller.es6
      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
      this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
      this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
      this.$sessionStorage[this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
      this.$sessionStorage[this.Const.SSAPP_SENSOR_RENTAL] = member.data.sensorRental;
      this.$sessionStorage[this.Const.SSAPP_IS_TMP_PASSWORD] = false;
      this.$timeout(() => {
        if (member.data.eulaAgree !== null && member.data.eulaAgree === 1) {
          this.$location.path('/member');
        } else {
          this.$location.path('/eula');
        }
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      }, 1500);
    })
    .catch((error) => {
      console.log('error : ', error);
      if (error) {
        if (error.statusCode === 400 && ~error.message.indexOf('limit exceeded')) {
          this.switchErrorMessage(this.Const.ERROR_TYPE.limit);
        } else {
          this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
        }
      } else {
        this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  staffLogin (id, tmpPass, newPass) {
    let userAuth = this.commonAuthFactory.staffLogin;
    userAuth(id, tmpPass, newPass).then((userCredentials) => {
      return this.commonAuthFactory.getCredentialsForAPI(userCredentials, localStorage.getItem(this.Const.LSAPP_ROLE));
    })
    .then(() => {
      return this.commonApiFactory.getStaffsMe();
    })
    .then((staff) => {
      this.switchErrorMessage(this.Const.ERROR_TYPE.clear);
      this.isChangeSuccess = true;
      this.$scope.$apply();
      this.$sessionStorage[this.Const.SSAPP_IS_TMP_PASSWORD] = false;
      this.$timeout(() => {
        switch (staff.role.name) {
          case this.Const.LSAPP_ROLE_C_ADMIN: // Company Admin
            this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_C_ADMIN);
            this.$sessionStorage[this.Const.SSAPP_COMPANY_ID] = staff.companyId;
            this.$location.path('/admin/school');
            break;
          case this.Const.LSAPP_ROLE_S_ADMIN: // School Admin
            this.commonFactory.setStorage(this.Const.LSAPP_ROLE, this.Const.LSAPP_ROLE_S_ADMIN);
            this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = staff.data.schoolId;
            this.$location.path('/admin');
            break;
          case this.Const.ROLE_COACH: // Staff
            this.$sessionStorage[this.Const.SSAPP_COACH_NAME] = staff.name;
            this.$sessionStorage[this.Const.SSAPP_COACH_GENDER] = staff.gender;
            this.$location.path('/staff');
            break;
          default: // Invalid Role
            this.commonFactory.flashErrorMessageFlag(
              this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, true
            );
        }
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      }, 1500);
    })
    .catch((error) => {
      console.log('error : ', error);
      if (error) {
        if (error.statusCode === 400 && ~error.message.indexOf('limit exceeded')) {
          this.switchErrorMessage(this.Const.ERROR_TYPE.limit);
        } else {
          this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
        }
      } else {
        this.switchErrorMessage(this.Const.ERROR_TYPE.loginFailed);
      }
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }
}

angular.module('myApp')
  .controller('PasswordChangeController', PasswordChangeController);



// WEBPACK FOOTER //
// ./app/components/password-change/password-change-controller.es6